import React, { useEffect, useState } from 'react';

import { Table } from 'react-bootstrap';

import { Activity, Attachment } from '../../../types/Activity';
import CollapsableItem from '../../utils/CollapsableItem';
import Modal from '../../utils/ModalComponet';
import * as ActivitiesService from '../../../services/ActivitiesService';
import Error from '../../stateMessage/Error';

import ActivityAttachmentRow from './ActivityAttachmentsRow';
import UploadActivityAttachment from './UploadActivityAttachment';

type Props = {
  activity: Activity;
};

const ActivityAttachments = (props: Props) => {
  const [showUploadModal, setShowUploadModal] = useState<boolean>(false);
  const [attachments, setAttachments] = useState<Attachment[]>([]);
  const [errorAlert, setErrorAlert] = useState<string>();

  useEffect(() => {
    setAttachments([
      ...(props.activity.attachments || []).sort((a, b) =>
        a.uploadedAt.localeCompare(b.uploadedAt)
      ),
    ]);
  }, [props.activity.attachments]);

  const showErrorAlert = (text: string) => {
    setErrorAlert(text);

    setTimeout(() => setErrorAlert(undefined), 2500);
  };

  const handleUploadButtonClick = () => {
    setShowUploadModal(true);
  };
  const handleUploadModalClose = () => {
    setShowUploadModal(false);
  };

  const handleAttachmentUploaded = async (attachment: Attachment) => {
    const updatedAttachments = [attachment, ...attachments];

    try {
      await ActivitiesService.updateActivity(props.activity.id, {
        attachments: updatedAttachments,
      });

      setAttachments(updatedAttachments);
    } catch (e) {
      showErrorAlert((e as Error).message);
    }
  };
  const handleAttachmentDelete = async (attachment: Attachment) => {
    const updatedAttachments = attachments.filter(a => a.id !== attachment.id);

    try {
      await ActivitiesService.updateActivity(props.activity.id, {
        attachments: updatedAttachments,
      });

      setAttachments(updatedAttachments);
    } catch (e) {
      showErrorAlert((e as Error).message);
    }
  };

  return (
    <div className={'data-box'}>
      <header className={'activity-section-top'}>
        <h4 className={'header'}>Attachments</h4>
        <div className='activity-section-buttons'>
          <button
            className={'btn btn-primary'}
            onClick={handleUploadButtonClick}
          >
            <i className={'fa fa-upload btn-icon'} />
            <span>Upload</span>
          </button>
        </div>
      </header>
      <CollapsableItem isExpanded>
        <div className={'activity__attachments-table'}>
          <Table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Type</th>
                <th>Uploaded at</th>
                <th className={'text-right'}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {attachments.map(attachment => (
                <ActivityAttachmentRow
                  key={attachment.id}
                  attachment={attachment}
                  onAttachmentDelete={handleAttachmentDelete}
                />
              ))}
            </tbody>
          </Table>
        </div>
      </CollapsableItem>
      <Modal open={showUploadModal} closeModal={handleUploadModalClose}>
        <UploadActivityAttachment
          activityId={props.activity.id}
          onAttachmentUploaded={handleAttachmentUploaded}
          onClose={handleUploadModalClose}
        />
      </Modal>

      {!!errorAlert && <Error text={errorAlert} />}
    </div>
  );
};

export default ActivityAttachments;
